module.exports = __webpack_public_path__ + "img/wheel-icon.f7d16ff3.svg";